import { render, staticRenderFns } from "./regional-section.vue?vue&type=template&id=74d2d6a9&scoped=true"
import script from "./regional-section.vue?vue&type=script&lang=js"
export * from "./regional-section.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d2d6a9",
  null
  
)

export default component.exports